import SignInForm from '@/components/SignInForm';
import {Alert, Container} from '@mui/material';
import type * as React from 'react';
import {useState} from 'react';

const SignIn: React.FC = () => {
    const [showInvalidCredentialsAlert, setShowInvalidCredentialsAlert] = useState<boolean>(false);

    return (
        <Container maxWidth='sm' sx={{mt: 3}}>
            <SignInForm setShowInvalidCredentialsAlert={setShowInvalidCredentialsAlert} />
            {showInvalidCredentialsAlert && (
                <Alert severity='error' sx={{mt: 2}}>
                    Invalid Username or Password
                </Alert>
            )}
        </Container>
    );
};

export default SignIn;
